import { Marker } from "@react-google-maps/api";
import React from "react";

import mapPin from "../../../images/svgs/icons/icon_map_pin.svg";
import mapPinSelected from "../../../images/svgs/icons/icon_map_pin_selected.svg";
import virtualPin from "../../../images/svgs/icons/icon_virtual_pin.svg";

interface MapMarkerProps {
	isSelected: boolean;
	onClick: () => void;
	latitude: number;
	longitude: number;
	// biome-ignore lint/suspicious/noExplicitAny: Do not have type for this from @react-google-maps/api
	clusterer?: any;
	isVirtual?: boolean;
}
const MapMarker: React.FC<MapMarkerProps> = ({
	isSelected,
	onClick,
	latitude,
	longitude,
	clusterer,
	isVirtual = false,
}) => {
	if (isVirtual)
		return (
			<Marker
				onClick={onClick}
				icon={{
					url: virtualPin,
				}}
				position={
					new window.google.maps.LatLng({
						lat: latitude,
						lng: longitude,
					})
				}
				clusterer={clusterer}
			/>
		);

	return (
		<Marker
			onClick={onClick}
			icon={{
				url: isSelected ? mapPinSelected : mapPin,
			}}
			position={
				new window.google.maps.LatLng({
					lat: latitude,
					lng: longitude,
				})
			}
			clusterer={clusterer}
		/>
	);
};

export default MapMarker;
